import { Stack, Typography, Button, TextField } from '@mui/material';
import { useState, Fragment } from 'react';
import useFetch from '../../hooks/useFetch';
import CircularProgress from '@mui/material/CircularProgress';
import { useLocation, useNavigate } from 'react-router-dom';

import { urlGetCertificationById } from '../../helpers';
import { FormCertification } from './components/FormCertification';
import { Message } from '../../components/Message';
import { messagesEditCertification } from '../../helpers/certificationMessage';
import { useForm } from '../../hooks/useForm';

export const EditCertification = () => {

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();
    const [formValues, handleInputChange] = useForm({
        certificationDate: ''
    });

    const { certificationDate } = formValues;

    const { data } = useFetch(`${urlGetCertificationById}?id=${searchParams.get('id')}`);
    const [products, setProducts] = useState([]);
    const [rents, setRents] = useState([]);
    const [body, setBody] = useState([]);
    const [saveOk, setSaveOk] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault()
        const { target } = e;
        const { firstDate, lastDate } = target;
        setBody({
            'rents': JSON.stringify(rents),
            "firstDate": firstDate?.value,
            "lastDate": lastDate?.value,
            "product": JSON.stringify(products),
            "id" : searchParams.get('id'),
            "certificationDate": certificationDate
        })
        setSaveOk(!saveOk)
    }

    return (
        <Stack width='100%' alignItems='center' mt={4}>
            <Stack className="form_certification" width='95%' component='form' onSubmit={handleSubmit}>
                <Typography textAlign='center' variant="h5" color="primary">Editar Certificación</Typography>
                <Stack width='90%' flexDirection='row' justifyContent='space-around' alignItems='flex-end'>
                <label >Fecha de certificación:</label >
                <TextField
                    sx={{ width: '200px', height: '30px' }}
                    type="date"
                    variant="standard"
                    name='certificationDate'
                    value={certificationDate ? certificationDate : ''}
                    onChange={handleInputChange}
                    required
                />
            </Stack>
                {data
                    ?
                    <Fragment>
                        <FormCertification setRents={setRents} data={data} setProducts={setProducts} />
                        <Stack flexDirection='row' flexWrap='wrap' justifyContent='flex-end' width='98%' gap={5} mb={1} mt={2}>
                            <Button sx={{ width: '100px' }} variant="outlined" size='small' onClick={() => navigate('/certification')}>Cancelar</Button>
                            <Button sx={{ width: '100px' }} variant="contained" size='small' type='submit'>Guardar</Button>
                        </Stack>
                    </Fragment>
                    : <Stack alignItems='center'><CircularProgress /> </Stack>}
            </Stack>
            {saveOk && <Message messages={messagesEditCertification} body={body} method='PUT' />}
        </Stack>
    )
}